export class DetalleProducto {
    id:string;
    codigoTerminal: string;
    codigoProducto: string;
    distanciaEnKM: number;
    toleranciaMensualOperativa: number;
    diasPromedio: number;
    diasDemora: number;
    stockSanitario: number;
}